const SchoolTypes = {
  SET_SCHOOLS_LOADING: 'SCHOOLS/SET_SCHOOLS_LOADING',
  SET_SCHOOLS_FAILURE: 'SCHOOLS/SET_SCHOOLS_FAILURE',
  SET_SCHOOLS_SUCCESS: 'SCHOOLS/SET_SCHOOLS_SUCCESS',
};

export default SchoolTypes;